var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 117,
    viewBox: "0 0 174 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.134 108.202H7.86407L0.164063 116.202V67.6922C0.164061 64.8561 1.29001 62.136 3.29449 60.1297C5.29896 58.1233 8.01798 56.9948 10.8541 56.9922H131.134C133.97 56.9948 136.689 58.1233 138.694 60.1297C140.698 62.136 141.824 64.8561 141.824 67.6922V97.5222C141.819 100.355 140.69 103.07 138.687 105.072C136.683 107.074 133.967 108.2 131.134 108.202Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1328 69.5234H126.133",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1328 81.5234H126.133",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1328 93.5234H104.133",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8528 41.2H166.133L173.833 49.2V10.69C173.83 7.85393 172.702 5.13491 170.695 3.13044C168.689 1.12596 165.969 1.74636e-05 163.133 1.87021e-05H86.8528C85.4468 -0.00260992 84.0541 0.271881 82.7543 0.807804C81.4544 1.34373 80.2729 2.13057 79.2774 3.12336C78.2818 4.11615 77.4917 5.29542 76.9521 6.59375C76.4125 7.89209 76.1341 9.28403 76.1328 10.69V30.52C76.1354 31.9252 76.4148 33.316 76.955 34.6132C77.4951 35.9104 78.2855 37.0885 79.2809 38.0802C80.2763 39.0719 81.4574 39.8579 82.7566 40.3932C84.0558 40.9285 85.4477 41.2026 86.8528 41.2Z",
    fill: "#E4E7EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M86.8528 41.2H166.133L173.833 49.2V10.69C173.83 7.85393 172.702 5.13491 170.695 3.13044C168.689 1.12596 165.969 1.74636e-05 163.133 1.87021e-05H86.8528C85.4468 -0.00260992 84.0541 0.271881 82.7543 0.807804C81.4544 1.34373 80.2729 2.13057 79.2774 3.12336C78.2818 4.11615 77.4917 5.29542 76.9521 6.59375C76.4125 7.89209 76.1341 9.28403 76.1328 10.69V30.52C76.1354 31.9252 76.4148 33.316 76.955 34.6132C77.4951 35.9104 78.2855 37.0885 79.2809 38.0802C80.2763 39.0719 81.4574 39.8579 82.7566 40.3932C84.0558 40.9285 85.4477 41.2026 86.8528 41.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.133 14.5234H92.1328",
    stroke: "#BEC2CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.133 26.5234H92.1328",
    stroke: "#BEC2CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.8528 41.2H166.133L173.833 49.2V10.69C173.83 7.85393 172.702 5.13491 170.695 3.13044C168.689 1.12596 165.969 1.74636e-05 163.133 1.87021e-05H86.8528C85.4468 -0.00260992 84.0541 0.271881 82.7543 0.807804C81.4544 1.34373 80.2729 2.13057 79.2774 3.12336C78.2818 4.11615 77.4917 5.29542 76.9521 6.59375C76.4125 7.89209 76.1341 9.28403 76.1328 10.69V30.52C76.1354 31.9252 76.4148 33.316 76.955 34.6132C77.4951 35.9104 78.2855 37.0885 79.2809 38.0802C80.2763 39.0719 81.4574 39.8579 82.7566 40.3932C84.0558 40.9285 85.4477 41.2026 86.8528 41.2Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFeedback);
export default __webpack_public_path__ + "static/media/myFeedback.4449dab9731f05b13c1f0dbe550bc35b.svg";
export { ForwardRef as ReactComponent };